import { parsePhoneNumberFromString } from "libphonenumber-js";
export function formatPhoneNumber(phoneNumber, country, format = "E.164", checkValidity = "none") {
    try {
        const targetRegion = (country && country.length > 0 ? country : "US");
        const parsed = parsePhoneNumberFromString(phoneNumber, targetRegion);
        if (!parsed)
            return null;
        if (checkValidity === "valid-region" && (!parsed.isValid() || parsed.country !== targetRegion)) {
            return null;
        }
        if (checkValidity === "valid" && !parsed.isValid()) {
            return null;
        }
        if (checkValidity === "possible" && !parsed.isPossible()) {
            return null;
        }
        return parsed.format(format);
    }
    catch {
        return null;
    }
}
export function formatUSOnlyPhoneNumber(phoneNumber) {
    return formatPhoneNumber(phoneNumber, "US", "E.164", "valid-region");
}
